import { Avatar } from "@heroui/react";
import { useEffect, useState } from "react";
import { BiRefresh } from "react-icons/bi";

type Props = {
  current?: string;
  onClick: (uuid: string) => void;
};

export class AvatarOption {
  uuid: string;

  constructor(uuid?: string) {
    this.uuid = uuid ?? window.crypto.randomUUID();
  }

  getUrl() {
    return `https://api.dicebear.com/9.x/avataaars/svg?seed=${this.uuid}&backgroundColor=f9d8cf`;
  }
}

const Emojis: React.FC<Props> = (props) => {
  const [avatarOptions, setAvatarOptions] = useState<AvatarOption[]>([]);

  useEffect(() => {
    loadAvatars();
  }, []);

  const loadAvatars = () => {
    const options: AvatarOption[] = [];
    options.push(new AvatarOption(props.current));
    options.push(...Array.from({ length: 22 }, () => new AvatarOption()));
    setAvatarOptions(options);
  };

  return (
    <div className="flex flex-row flex-wrap gap-2" data-cy="emojis">
      {avatarOptions.map((option) => (
        <Avatar
          key={option.uuid}
          src={option.getUrl()}
          isBordered={option.uuid == props.current}
          className="ring-primary-700"
          onClick={props.onClick.bind(null, option.uuid)}
        />
      ))}
      <Avatar key="rerender" icon={<BiRefresh size={24} />} isBordered={false} className="ring-primary-700" onClick={() => loadAvatars()} />
    </div>
  );
};

export default Emojis;
